import React from 'react';
// import ServiceCard from './ServiceCard'; // Assuming ServiceCard is a separate component
import Discount from '../../../Assets/img/Homepage/discount.svg';

const ServiceSection = ({
    title = "Services",
    serviceNames = [],
    showAll,
    toggleView,
    maxVisible = 6,
    handleClick,
    Selected,
    type,
}) => {

    return (
        <div className="sec-box-heightCommon d-flex flex-column my-2 px-3">
            {/* Title and View All/View Less */}
            <div
                className="d-flex flex-row justify-content-between px-3 py-2"
            // style={{ paddingTop: "5px" }}
            >
                <p className="card-title">{title}</p>
                <p
                    className="card-title"
                    style={{ color: '#0044C6', cursor: 'pointer' }}
                    onClick={toggleView}
                >
                    {showAll ? 'View Less' : 'View All'}
                </p>
            </div>

            {/* Services Container */}
            <div
                className="mx-1 mb-2"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                }}
            >
                {(showAll ? serviceNames : serviceNames.slice(0, maxVisible)).map((serviceName, index) => (
                    <ServiceCards 
                        key={index} 
                        text={serviceName} 
                        isSelected={Selected === index} 
                        onClick={() => handleClick(index, type)} 
                    />
                ))}
            </div>
        </div>
    );
};

export default ServiceSection;

// Updated ServiceCards - Only logo size changed for organizations
const ServiceCards = ({ text, onClick, isSelected }) => {
    // Check if this is an organization item
    const isOrganization = text.isOrganization || false;
    
    return (
        <div className="service-card mx-1 d-flex flex-column my-2" onClick={onClick}>
            <img 
                src={text.icon} 
                alt='image' 
                style={{
                    width: isOrganization ? '32px' : '32px',
                    height: isOrganization ? '32px' : '32px',
                    objectFit: 'contain',
                }}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = text.fallbackIcon || text.icon;
                }}
            />
            <span style={{ 
                textAlign: "center", 
                fontSize: isOrganization ? '9px' : '14px'
            }}>
                {text.name}
            </span>
            {isOrganization && text.roleName && (
                <span style={{
                    textAlign: "center",
                    fontSize: '12px',
                    color: '#999',
                    marginTop: '1px',
                }}>
                    {text.roleName}
                </span>
            )}
        </div>
    );
};